import React, { useEffect, useState } from "react";
import { Container, Form, Offcanvas, Table } from "react-bootstrap";
import { globalFormManagementServices } from "../../../../APIServices/globalFormManagementServices";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FormFieldLibrary = ({
  Show,
  Hide,
  formFieldLibraryList,
  categoryId,
  setCategoryId,
  setFormFields,
  formFields,
}) => {
  const [formFieldList, setFormFieldList] = useState([]);
  const [formFieldData, setFormFieldData] = useState([]);
  const [selectedFormField, setSelectedFormField] = useState({});

  const findGlobalFormFieldGroupLibrary = async (e) => {
    let data =
      await globalFormManagementServices.findGlobalFormFieldGroupLibrary(
        categoryId
      );
    setFormFieldList(data?.data || []);
  };

  useEffect(() => {
    findGlobalFormFieldGroupLibrary();
  }, [categoryId]);

  const handleCheckboxChange = (checked, field) => {
    setSelectedFormField((prev) => {
      const updated = { ...prev };
      if (checked) {
        updated[field.fieldName] = true;
      } else {
        delete updated[field.fieldName];
      }
      return updated;
    });
    if (checked) {
      setFormFieldData([...formFieldData, field]);
    } else {
      let filteredField = formFieldData?.filter(
        (item) => item.id !== field?.id
      );
      setFormFieldData(filteredField);
    }
  };

  const handleSelectAllChange = (checked) => {
    if (checked) {
      const newSelected = {};
      formFieldList.forEach((field) => {
        newSelected[field.fieldName] = true;
      });
      setSelectedFormField(newSelected);
      setFormFieldData([...formFieldList]);
    } else {
      setSelectedFormField({});
      setFormFieldData([]);
    }
  };

  const handleApplyChange = () => {
    let finalFormFiels = updateIds(formFieldData);
    setFormFields([...formFields, ...finalFormFiels]);
    setFormFieldData([]);
    setSelectedFormField({});
  };

  function updateIds(obj) {
    if (Array.isArray(obj)) {
      return obj.map(updateIds);
    } else if (typeof obj === "object" && obj !== null) {
      const newObj = { ...obj };
      if ("id" in newObj) {
        newObj.id = Math.floor(1000000000 + Math.random() * 9000000000);
      }
      for (const key in newObj) {
        if (typeof newObj[key] === "object") {
          newObj[key] = updateIds(newObj[key]);
        }
      }
      return newObj;
    } else {
      return obj;
    }
  }

  const isChecked = (fieldName) => !!selectedFormField[fieldName];
  const allSelected =
    formFieldList.length > 0 &&
    formFieldList.every((field) => selectedFormField[field.fieldName]);

  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        placement="end"
        style={{ width: "500px" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Field Library</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="p-2">
            <Form.Select
              onChange={(e) => setCategoryId(e.target.value)}
              className="br3 mb-2"
              style={{ fontSize: 12 }}
            >
              <option selected={categoryId === ""} value="">
                Select Library
              </option>
              {formFieldLibraryList?.map((item, index) => (
                <option
                  key={index}
                  selected={categoryId === item?.categoryId}
                  value={item?.categoryId}
                >
                  {item?.categoryName}
                </option>
              ))}
            </Form.Select>
          </div>
          {formFieldList?.length === 0 ? (
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 550px)" }}
            >
              <NoDataFoundTable MSG={"Field Library not found!"} />
            </div>
          ) : (
            <>
              <Table className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th style={{ width: 45 }} className="text-center">
                      <Form.Check
                        type="checkbox"
                        checked={allSelected}
                        onChange={(e) =>
                          handleSelectAllChange(e.target.checked)
                        }
                      />
                    </th>
                    <th>Field Label</th>
                    <th>Field Name</th>
                    <th style={{ width: 100 }}>Field Type</th>
                  </tr>
                </thead>
                <tbody>
                  {formFieldList?.map((item, index) => (
                    <tr key={`dynamic-${index}`}>
                      <td className="text-center">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(item.fieldName)}
                          onChange={(e) =>
                            handleCheckboxChange(e.target.checked, item)
                          }
                        />
                      </td>
                      <td>{item?.fieldLabel}</td>
                      <td>{item?.fieldName}</td>
                      <td>{item?.type}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Offcanvas.Body>
        {formFieldList?.length > 0 && (
          <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
            <button
              onClick={handleApplyChange}
              disabled={Object.keys(selectedFormField)?.length === 0}
              className="updateProfile"
            >
              Add Fields
            </button>
          </div>
        )}
      </Offcanvas>
    </>
  );
};

export default FormFieldLibrary;
